/* tslint:disable */
import React, { Suspense, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import 'maplibre-gl/dist/maplibre-gl.css'

import usePageLoaded from '../../hooks/usePageLoaded'

import GeoUserList from './geoUserList'
import GeoFilter from './geoFilter'
import Title from '../../components/ui/title/title'

import { Formik } from 'formik'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'

import { RootState } from '../../store/rootReducer'
import { GeoState, Options } from '../../store/geo/geoTypings'

import { fetchGeo, updateFilters } from '../../store/geo/geoSlice'
import { getLangFromPath } from '../../i18next'
import { updateGeoOptions } from '../../api/geo'
import './geo.sass'
import { openMenu } from '../../store/common/commonSlice'
import FAQ from '../../components/ui/popup/FAQ'

const GeoMap = React.lazy(() => import('./GeoMap'))

const initialValues = {
    range: 0,
    gender: 0,
    position: 0,
    shareLocation: 0,
    age: 0,
    followers: 0,
    followees: 0,
    humor: ''
}

const Geo = () => {
    usePageLoaded()

    const [t] = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()

    const { list, userLocations, filters } = useSelector<RootState, GeoState>((state) => state.geo)
    const loggedIn = useSelector((state: RootState) => state.member.loggedIn)
    const triedLoad = useSelector((state: RootState) => state.member.triedLoad)
    const user = useSelector((state: RootState) => state.member.user)

    const [showMoreFilters, setShowMoreFilters] = useState(false)
    const [currentCenter, setCurrentCenter] = useState({ lat: userLocations.lat, lng: userLocations.lon })
    const [currentDistance, setCurrentDistance] = useState(30)
    const cordsLoaded = useRef(false)

    const [currenOrder, setCurrenOrder] = useState('random')

    const [pageLoaded, setPageLoaded] = useState(false)

    useEffect(() => {
        if (!pageLoaded && triedLoad) setPageLoaded(true)
    }, [triedLoad])

    useEffect(() => {
        if (!cordsLoaded.current && userLocations.lat !== currentCenter.lat) {
            setCurrentCenter({ lat: userLocations.lat, lng: userLocations.lon })
            cordsLoaded.current = true
        }
    }, [userLocations.lat, userLocations.lon])

    useEffect(() => {
        if (filters) {
            updateGeoOptions({
                precision: !isNaN(+filters.precision) ? filters.precision : 3000,
                shareMyLocation: filters.shareMyLocation ? filters.shareMyLocation : 0
            })
        }
        if (filters) {
            const localFilters: Options = JSON.parse(localStorage.getItem('geoFilters'))
            dispatch(
                fetchGeo({
                    d: currentDistance ? currentDistance : 30,
                    gender: localFilters ? Number(localFilters.gender) : 0,
                    age: localFilters ? Number(localFilters.age) : 0,
                    followers: localFilters && loggedIn ? Number(localFilters.followers) : 0,
                    followees: localFilters && loggedIn ? Number(localFilters.followees) : 0,
                    lat: currentCenter.lat,
                    lon: currentCenter.lng,
                    order: currenOrder
                })
            )
        }
    }, [filters, currenOrder, currentCenter.lat])

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                showMoreFilters && setShowMoreFilters(false)
                const pureObj: Options = {
                    precision: values.position,
                    gender: values.gender,
                    age: values.age,
                    followers: values.followers,
                    followees: values.followees,
                    shareMyLocation: values.shareLocation,
                    message: values.humor
                }
                dispatch(updateFilters(pureObj))
                localStorage.setItem('geoFilters', JSON.stringify(pureObj))
            }}
        >
            <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
                <Helmet>
                    <title>{META.geo[getLangFromPath(location.pathname)].title}</title>
                    <meta name="description" content={META.geo[getLangFromPath(location.pathname)].description} />
                </Helmet>
                <Title text={t('Around me')} />
                <GeoFilter showMoreFilters={showMoreFilters} setShowMoreFilters={setShowMoreFilters} />

                {pageLoaded && (
                    <Suspense fallback={null}>
                        <GeoMap setCurrentCenter={setCurrentCenter} setCurrentDistance={setCurrentDistance} />
                    </Suspense>
                )}

                <FAQ>
                    <>
                        <p>{t('Authorize the bobvoyeur-com site to access your location in your browser')}</p>
                        <p>
                            {t(
                                'Share your position on the map to estimate the distances between you and other members'
                            )}
                        </p>
                        <p>{t('ThirdLineFAQGeo')}</p>
                        <p>{t('Write a short mood text to describe your interests')}</p>
                        <p>{t('FivesLineFAQGeo')}</p>
                    </>
                </FAQ>
                <div className="geoUsersList">
                    <div className="usersList">
                        {list.length ? (
                            <GeoUserList
                                userList={list.filter((item) => item.id && item.nick)}
                                currentOrder={currenOrder}
                                setCurrentOrder={setCurrenOrder}
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
            </div>
        </Formik>
    )
}

// // @ts-ignore
// Geo.getInitialProps = async ({ store }) => {
//     await checkAuth(store)
// }

export default Geo
